import React from 'react'

const getBackground = (count: number, isDarkMode: boolean) => {
	if (count <= 18)
		return isDarkMode
			? 'radial-gradient(50% 50% at 50% 50%, #ffffff 0%, #aabbd6 100%)'
			: 'radial-gradient(50% 50% at 50% 50%, #ffffff 0%, #d6e4ff 100%)'
	if (count <= 25)
		return isDarkMode
			? 'radial-gradient(50% 50% at 50% 50%, #ffffff 0%, #e0c290 100%)'
			: 'radial-gradient(50% 50% at 50% 50%, #ffffff 0%, #ffdf99 100%)'
	if (count <= 30)
		return isDarkMode
			? 'radial-gradient(50% 50% at 50% 50%, #ffffff 0%, #e4bfc5 100%)'
			: 'radial-gradient(50% 50% at 50% 50%, #ffffff 0%, #ffd6dc 100%)'
	return isDarkMode
		? 'radial-gradient(50% 50% at 50% 50%, #ffffff 0%, #d19aa5 100%)'
		: 'radial-gradient(50% 50% at 50% 50%, #ffd6dc 0%, #ff99a8 100%)'
}

const getBlockColor = (count: number) => {
	if (count <= 18) return '#5C95FF'
	if (count <= 25) return '#FFB30D'
	if (count <= 30) return '#FF99A8'
	return '#FF193B'
}

interface BlockGeneratorProps {
	count: number
	isDarkMode: boolean
}

const BlockGenerator: React.FC<BlockGeneratorProps> = ({ count }) => {
	const minTemp = 18
	const maxTemp = 31
	const minBlocks = 5
	const maxBlocks = 33

	const createBlocks = () => {
		const blocks = []
		const radius = 125
		const curveAdjustment = 90

		const coloredBlocks =
			((count - minTemp) * (maxBlocks - minBlocks)) / (maxTemp - minTemp) + minBlocks

		for (let i = 0; i < 33; i++) {
			const angle = (i * (180 + curveAdjustment)) / (33 - 1) - curveAdjustment / 2
			const x = radius * Math.cos((angle * Math.PI) / 180)
			const y = radius - radius * Math.sin((angle * Math.PI) / 180)
			const isEdgeBlock = i === 0 || i === 33 - 1
			const width = isEdgeBlock ? '7px' : '9px'
			const blockColor = i >= 33 - coloredBlocks ? getBlockColor(count) : 'gray'

			blocks.push(
				<div
					style={{
						backgroundColor: blockColor,
						width: width,
						height: '1rem',
						position: 'absolute',
						left: `calc(50% + ${x}px - ${width}/2)`,
						top: `${y}px`,
						transform: `rotate(${90 - angle}deg)`,
					}}
					key={i}
				/>
			)
		}

		return blocks
	}

	return <div>{createBlocks()}</div>
}

export { BlockGenerator, getBackground }
